import { useEffect, useState } from 'react';
import { db } from '../firebase/config';
import { collection, onSnapshot, query, where, orderBy } from 'firebase/firestore';

export const useCollection = (c, options) => {
  const [documents, setDocuments] = useState(null);
  const [error, setError] = useState(null);
  const [isPending, setIsPending] = useState(true);

  // Use JSON.stringify of options to use as a dependency
  const optionsString = JSON.stringify(options);

  useEffect(() => {
    setIsPending(true);
    let ref = collection(db, c);
    
    const constraints = [];
    if (options) {
        if (options.where) {
            // where is expected to be an array like ['category', '==', 'Farmer']
            constraints.push(where(...options.where));
        }
        if (options.orderBy) {
            // orderBy is expected to be an array like ['createdAt', 'desc']
            constraints.push(orderBy(...options.orderBy));
        }
    }

    const q = query(ref, ...constraints);

    const unsubscribe = onSnapshot(q,
      (snapshot) => {
        const results = [];
        snapshot.docs.forEach(doc => {
            results.push({...doc.data(), id: doc.id});
        });
        
        setDocuments(results);
        setError(null);
        setIsPending(false);
      },
      (err) => {
        console.error(err.message);
        setError('Could not fetch the data');
        setIsPending(false);
      }
    );

    return () => unsubscribe();

  }, [c, optionsString]); // Dependency on the stringified options

  return { documents, error, isPending };
};
